import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_HOTEL_ACCOMMODATIONS, res.data)
  })
)

export const getTypeAccomodations = ({ commit }, params) => (
  services.typesAccommodations(params).then(res => {
    return res.data
  })
)

export const getAccommodation = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_HOTEL_ACCOMMODATION, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  // O `return` dentro do .then não saía da action — quem chamava recebia
  // undefined. Agora a resposta chega ao componente, que precisa dela para
  // avisar sobre quartos que não puderam ser removidos.
  const res = await services.saveAccommodation(obj)
  commit(types.SET_HOTEL_ACCOMMODATION, res.data.data)
  return res
}

export const deleteAccommodation = async ({ commit }, id) => {
  await services.delAccommodation(id).then(res => {
    return res
  })
}
